import styled from 'styled-components';

import {type ReactNode, useRef} from 'react';

import {useOnMount} from 'shared/web';

interface AiComposerFocusRegionProps {
  children: ReactNode;
  role: 'status' | 'group';
  'aria-label'?: string;
  'aria-live'?: 'polite';
}

export function AiComposerFocusRegion(props: AiComposerFocusRegionProps) {
  const ref = useRef<HTMLDivElement>(null);

  useOnMount(() => ref.current?.focus());

  return (
    <Region
      ref={ref}
      tabIndex={-1}
      role={props.role}
      aria-label={props['aria-label']}
      aria-live={props['aria-live']}
    >
      {props.children}
    </Region>
  );
}

// The region takes focus when it appears, so screen readers announce it. Its outline sat on the
// first letter of every line (seen in review); the padding keeps the text clear of it.
const Region = styled.div`
  padding: ${({theme}) => theme.getSize(1)};
  border-radius: ${({theme}) => theme.radii.small};

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: ${({theme}) => theme.outline.default}
      ${({theme}) => theme.colors.palettes.purple[60][100]};
  }
`;
